import React from "react";
import GoogleLogin from "./GoogleLogin";

const AuthScreen: React.FC = () => {
  return (
    <div className="auth-screen">
      <div className="auth-container">
        <div className="game-logo">
          <h1>🎮 Idle Clicker Game</h1>
          <p>Click to collect items and build your inventory!</p>
        </div>

        <div className="auth-content">
          <GoogleLogin />
          <div className="auth-info">
            <p>Sign in with your Google account to start playing!</p>
            <p className="auth-note">
              Your Google profile information will be used to create your game
              account.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
